const SHOW_PERSON_TAG_INFO = "SHOW_PERSON_TAG_INFO";

export const showPersonTagInfo = (data) => (dispatch) =>
  dispatch({ type: SHOW_PERSON_TAG_INFO, data });

export const closePersonTagInfo = () => (dispatch) =>
  dispatch({ type: SHOW_PERSON_TAG_INFO, data: null });

const initialState = {
  personTagInfo: null,
};

export default function PersonDialogReducer(state = initialState, action) {
  switch (action.type) {
    case SHOW_PERSON_TAG_INFO:
      return {
        ...state,
        personTagInfo: action.data,
      };
    default:
      return state;
  }
}
